import React, { Component } from 'react';
import ConfigAssistant from '../../common/configAssistant/ConfigAssistant';
import MatrixConflictModalMessage from './MatrixConflictModalMessage';
import ConfigAssistantDriveToggle from '../../common/configAssistant/ConfigAssistantDriveToggle';
import { uniqBy } from 'lodash';
import TrimsAndEnginesListView from '../../common/configAssistant/TrimsAndEnginesListView';
import ConfigsAndEnginesListView from '../../common/configAssistant/ConfigsAndEnginesListView';

class MatrixConflictConfigAssistant extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      type,
      id,
      driveOptions,
      options,
      classicModel,
      selectedDriveOption,
      selectedOption,
      onDriveOptionChange,
      onOptionChange
    } = this.props;

    const hasSingleEngine = uniqBy(options, 'engine').length === 1;
    const hasSingleDriveOption = driveOptions.length === 1;

    const ListView = classicModel
      ? TrimsAndEnginesListView
      : ConfigsAndEnginesListView;

    return (
      <ConfigAssistant
        message={
          <MatrixConflictModalMessage
            options={options}
            hasSingleDriveOption={hasSingleDriveOption}
            hasBodyTypes={!classicModel}
            hasSingleEngine={hasSingleEngine}
            type={type}
            id={id}
          />
        }
        driveToggle={
          driveOptions.length > 1 ? (
            <ConfigAssistantDriveToggle
              options={driveOptions}
              selected={selectedDriveOption}
              onChange={onDriveOptionChange}
            />
          ) : null
        }
        list={
          <ListView
            options={options}
            driveOptions={driveOptions}
            flattened={hasSingleEngine}
            selectedDriveOption={selectedDriveOption}
            selectedOption={selectedOption}
            onChange={onOptionChange}
          />
        }
      />
    );
  }
}

export default MatrixConflictConfigAssistant;
